import selectors from '../rootSelectors';
import { SPELLING_FETCH_RETRY } from '../common/api/apiRetryGetConstants';
import SpellingServiceClient from '../common/clients/SpellingServiceClient';
import { selectMultipleResponses } from '../common/questions/questionsActions';

export const SET_SPELLING_CONTENT = 'SET_SPELLING_CONTENT';
export const SET_ENABLED_RESPONSES = 'SET_ENABLED_RESPONSES';
export const SET_READY_SCRIPT_PLAYED = 'SET_READY_SCRIPT_PLAYED';
export const SET_BUTTON_GRID_ENABLED = 'SET_BUTTON_GRID_ENABLED';
export const SET_CLEAR_BUTTON_ENABLED = 'SET_CLEAR_BUTTON_ENABLED';

export const setSpellingContent = (content) => ({
    type: SET_SPELLING_CONTENT,
    content,
});

export const fetchSpellingContent = () => (dispatch, getState) => {
    const state = getState();
    const grade = selectors.getGrade(state);
    const period = selectors.getToy(state);
    const language = selectors.getCurrentLanguage(state);

    return dispatch(SpellingServiceClient.getForm(grade, period, language, SPELLING_FETCH_RETRY))
        .then((content) => {
            dispatch(setSpellingContent(content));
        });
};

export const setEnabledResponses = (responses) => ({
    type: SET_ENABLED_RESPONSES,
    responses,
});

export const setReadyScriptPlayed = () => ({
    type: SET_READY_SCRIPT_PLAYED,
});

export const setButtonGridEnabled = (isEnabled) => ({
    type: SET_BUTTON_GRID_ENABLED,
    isEnabled,
});

export const setClearButtonEnabled = (isEnabled) => ({
    type: SET_CLEAR_BUTTON_ENABLED,
    isEnabled,
});

export const selectPossibleResponses = (letter) => (dispatch, getStore) => {
    const state = getStore();
    const selectedResponses = selectors.getMultiChoiceResponses(state);

    if (selectedResponses.length > 14) {
        return null;
    }

    const nextSelectedResponses = [...selectedResponses, letter];
    return dispatch(selectMultipleResponses(nextSelectedResponses));
};
